// src/app/routes/timker2Routes.jsx
import React, { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import RequireTimker2Auth from "../../auth/RequireTimker2Auth";

const Timker2LoginPage = lazy(() => import("../../pages/timker2/Timker2LoginPage"));
const Timker2DashboardPage = lazy(() => import("../../pages/timker2/Timker2DashboardPage"));
const Timker2SraDataPage = lazy(() => import("../../pages/timker2/Timker2SraDataPage"));
const Timker2AuditLogPage = lazy(() => import("../../pages/timker2/Timker2AuditLogPage"));
const Timker2PemeriksaanPage = lazy(() => import("../../pages/timker2/Timker2PemeriksaanPage"));
const Timker2BeritaAcaraPage = lazy(() => import("../../pages/timker2/Timker2BeritaAcaraPage"));
const Timker2BeritaAcaraListPage = lazy(() =>
  import("../../pages/timker2/Timker2BeritaAcaraListPage")
);
const Timker2BeritaAcaraVerifyPage = lazy(() =>
  import("../../pages/timker2/Timker2BeritaAcaraVerifyPage")
);
const Timker2SampelLaboratoriumDataPage = lazy(() =>
  import("../../pages/timker2/Timker2SampelLaboratoriumDataPage")
);
const Timker2SampelLaboratoriumSuratEditorPage = lazy(() =>
  import("../../pages/timker2/Timker2SampelLaboratoriumSuratEditorPage")
);
const Timker2LaluLintasJenazahDataPage = lazy(() =>
  import("../../pages/timker2/Timker2LaluLintasJenazahDataPage")
);
const Timker2KirimDokumenPage = lazy(() =>
  import("../../pages/timker2/Timker2KirimDokumenPage")
);

const protectedTimker2 = (element) => <RequireTimker2Auth>{element}</RequireTimker2Auth>;

export function renderTimker2Routes() {
  return (
    <>
      <Route path="/timker2/login" element={<Timker2LoginPage />} />
      <Route path="/timker2" element={<Navigate to="/timker2/dashboard" replace />} />
      <Route
        path="/timker2/dashboard"
        element={protectedTimker2(<Timker2DashboardPage />)}
      />
      <Route path="/timker2/sra" element={protectedTimker2(<Timker2SraDataPage />)} />
      <Route
        path="/timker2/log-perubahan"
        element={protectedTimker2(<Timker2AuditLogPage />)}
      />
      <Route
        path="/timker2/audit-log"
        element={<Navigate to="/timker2/log-perubahan" replace />}
      />
      <Route
        path="/timker2/pemeriksaan/:assessmentId"
        element={protectedTimker2(<Timker2PemeriksaanPage />)}
      />
      <Route
        path="/timker2/sampel-laboratorium"
        element={protectedTimker2(<Timker2SampelLaboratoriumDataPage />)}
      />
      <Route
        path="/timker2/sampel-laboratorium/:sampelId/surat-keterangan/editor"
        element={protectedTimker2(<Timker2SampelLaboratoriumSuratEditorPage />)}
      />
      <Route
        path="/timker2/lalu-lintas-jenazah"
        element={protectedTimker2(<Timker2LaluLintasJenazahDataPage />)}
      />
      <Route
        path="/timker2/berita-acara"
        element={protectedTimker2(<Timker2BeritaAcaraPage />)}
      />
      <Route
        path="/timker2/kirim-dokumen"
        element={protectedTimker2(<Timker2KirimDokumenPage />)}
      />
      <Route
        path="/timker2/berita-acara/daftar"
        element={protectedTimker2(<Timker2BeritaAcaraListPage />)}
      />
      <Route
        path="/timker2/berita-acara/list"
        element={<Navigate to="/timker2/berita-acara/daftar" replace />}
      />
      <Route
        path="/timker2/berita-acara/verify/:token"
        element={<Timker2BeritaAcaraVerifyPage />}
      />
    </>
  );
}
